import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router"
import { ClienteLogin, CiudadClienteNombre } from '../../../views/login/cliente_login';
import { UbicacionEntity } from "../../../views/masivos/datosGenerales/entities/ubicacion_entity"
import { CIUDADES } from "../cabecera/entity/ciudades";
import { ClienteVAM } from "../../../views/login/cliente_login";
import { ClienteIndividualEntity } from "../../../views/masivos/datosGenerales/entities/datos_generales_individual_entity";
import { DatosGeneralesService } from "../../../views/masivos/datosGenerales/datos-generales.service";
import { HandleError } from "../utils/handleError.component";
import { ConsultarUsuarioVAM } from "../utils/consultarUsuarioVAM";
import { SessionStorageService, SessionStorage } from "ngx-webstorage";
import { LoginService } from '../../../views/login/login.service';


declare var jQuery: any;

@Component({
    selector: 'cabeceraVamTitulares',
    templateUrl: 'cabecera-vam-titulares.template.html',
    styleUrls: ["cabecera-vam-titulares.style.css"]
})

export class CabeceraVAMTitulares implements OnInit {
    NombreUsuario: string;
    usuario: ClienteLogin;
    comboCiudad: CiudadClienteNombre[];
    inicial: CiudadClienteNombre;
    lengthCombo: boolean;
    nombreUser: ClienteVAM;
    usuarioVam: ClienteVAM = new ClienteVAM();
    clienteMasivosIndividual: ClienteIndividualEntity;
    codUnicoInicial: number = 0;
    constructor(
        private sesionStorageService: SessionStorageService, 
        private router: Router, 
        private datosGeneralesIndividualSevice: DatosGeneralesService, 
        private handleError: HandleError, 
        private consultarVAM: ConsultarUsuarioVAM,
        private loginService: LoginService) {}

    ngOnInit(): void {
            this.inicial = new CiudadClienteNombre();
            this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
            this.nombreUser = jQuery.parseJSON(this.sesionStorageService.retrieve("uservam"));
            this.consultarTodo();
            this.sesionStorageService.observe("usuario").subscribe(v => {
                this.usuario = jQuery.parseJSON(v);
                this.consultarTodo();
            });
            this.sesionStorageService.observe("uservam").subscribe(v => {
                this.nombreUser = jQuery.parseJSON(v);
                this.consultarTodo();
            });
    }

    consultarTodo(){
        this.consultarVAM.iniciarUsuarioVAM(); 
            if (this.usuario != null) {
                try{
                    this.NombreUsuario = jQuery.parseJSON(this.sesionStorageService.retrieve("NombreUser"));
                }catch(e){
                    this.NombreUsuario = this.sesionStorageService.retrieve("NombreUser");
                }
    
                
                this.sesionStorageService.observe("NombreUser").subscribe(v => {
                    try{
                        this.NombreUsuario = jQuery.parseJSON(v);
                    }catch(e){
                        this.NombreUsuario = v;
                    }
                    
                });
                if (this.usuario.VAM != null) {
                    if (this.router.url.includes("VAM")) {
                        let contador = 1;
                        this.comboCiudad = new Array<CiudadClienteNombre>();
                        this.lengthCombo = this.usuario.VAM.length > 1 ? true : false;
                        this.usuario.VAM.forEach(element => {
                            CIUDADES.forEach(a => {
                                if (a.Codigo == element.CodigoCiudad) {
                                    let clienteVamLista = new CiudadClienteNombre();
                                    clienteVamLista.CodigoCiudad = a.Codigo;
                                    clienteVamLista.CodigoCliente = element.CodigoCliente;
                                    clienteVamLista.Unidad = element.CodigoUnidad;
                                    clienteVamLista.NombreCombo = element.NombreEmpresa;
                                    clienteVamLista.idUnico = contador;
                                    this.comboCiudad.push(clienteVamLista);
                                    contador++;
                                }
                            });
                        });
                        let inicialVam = new CiudadClienteNombre();
                        if (this.nombreUser == null) {
                            inicialVam.CodigoCiudad = this.usuario.VAM[0].CodigoCiudad;
                            inicialVam.CodigoCliente = this.usuario.VAM[0].CodigoCliente;
                            inicialVam.Unidad = this.usuario.VAM[0].CodigoUnidad;
                            inicialVam.NombreCombo = this.usuario.VAM[0].NombreEmpresa;
                            this.inicial = inicialVam;
                            
                        } else {
                            inicialVam.CodigoCiudad = this.nombreUser.CodigoCiudad;
                            inicialVam.CodigoCliente = this.nombreUser.CodigoCliente;
                            inicialVam.Unidad = this.nombreUser.CodigoUnidad;
                            inicialVam.NombreCombo = this.nombreUser.NombreEmpresa;
                            this.inicial = inicialVam;
                        }
                        this.inicial = this.comboCiudad.filter(a=>a.CodigoCiudad == this.inicial.CodigoCiudad && a.CodigoCliente == this.inicial.CodigoCliente)[0];
                        this.codUnicoInicial = this.inicial.idUnico;
                    } else {
                        this.lengthCombo = false;
                    }
                }
            }
    }

    onCiudadChange(codCiudad: any) {
        let userVam = this.comboCiudad.filter(a=>a.idUnico == (codCiudad.target.value*1))[0];
        this.usuario.VAM.forEach(element => {
            if (element.CodigoCiudad == userVam.CodigoCiudad && element.CodigoCliente == userVam.CodigoCliente) {
                this.sesionStorageService.store("uservam",JSON.stringify(element));
                this.consultaMenu(element);
            }
        });
    }

    consultaMenu(valor: ClienteVAM){
        this.loginService.consultarMenuXCliente(valor.CodigoCliente,valor.CodigoCiudad,1).subscribe(
            result=>{
                this.usuario.Menu.forEach(a=>{
                    if(a.CodigoMenu == result[0].CodigoMenu){
                        a.Hijos = result[0].Hijos;
                    }
                });        
                this.sesionStorageService.store("usuario",JSON.stringify(this.usuario));        
                location.reload(); 
            },
            error=>{
                this.handleError.redirectUrl(error)
            }
        );
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/cabeceraVAMTitulares/cabecera-vam-titulares.component.ts